import React, { Component } from "react";
import PropTypes from "prop-types";
import {
  Col,
  Modal,
  Collapse,
  CardBody,
  Card,
  ModalBody,
  ModalHeader,
  Button,
  Row,
} from "reactstrap";
import { withTranslation } from "react-i18next";
import { Link } from "react-router-dom";
import {
  padLeft
} from "../../components/Common/TableComponents/AgTable/CellRenderers/CellFunctions";
class ErrorModal extends Component {
  constructor(props) {
    super(props);
    this.state = {
      collapse: false,
      validation: false,
      record : {
        message: "",
        code: "",
        details: "",
        correlationId: "",
        validationResults: [],
      }
    };
    this.t_collapse = this.t_collapse.bind(this);
  }

  t_collapse() {
    this.setState(prevState => ({ collapse: !prevState.collapse }));
  }

  componentDidMount() {
    const { record } = this.state;
    const { errorMessage } = this.props;

    if (errorMessage) {
      if (errorMessage.response && errorMessage.response.data != '') {
        let a = JSON.parse(errorMessage.response.data);
        record.code = a.Code;
        record.message = a.Message;
        record.details = a.Details;
        record.correlationId = a.CorrelationId;
        record.validationResults = a.validationResults;
      }
      else if (errorMessage) {
        record.code = errorMessage.code;
        record.message = errorMessage.message;
        record.details = errorMessage.name + " => ";
        record.details += errorMessage.config ? errorMessage.config.url : "";
        record.correlationId = 0;
      } else {
        record.code = "Unhandled Exeption";
        record.message = "Please contact with Administrator";
        record.details = "Admin => Details";
      }

      if (record && record.code && record.code.includes("RVV")) {
        this.setState({ validation: true });
        if (record.validationResults)
        {
          record.code = record.code.replace("999999","")+""+padLeft(record.validationResults[0].ErrorMessage,6,0);
        }
      }

    }

  }


  render() {
    const { validation,record } = this.state;

    return (
      <React.Fragment>
        <Modal
          isOpen={true}
          toggle={this.props.onCloseModalClick}
          centered={false}
        >
          {validation ?
            (
              <ModalBody>
                <Row>
                  <Col lg={18}>
                    <div>
                      <h5 style={{ color: "orange" }}> <i className="bx bx-info-circle" style={{ "marginRight": "3px", "marginTop": "-4px", fontSize: "1.5em", color: "orange" }} />{this.props.t("operationValidation")}</h5>
                    </div>
                    <div className="modal-body"  style={{fontSize: "1.2em" }} >
                      <p>{record.code}</p>
                      <p>{this.props.t(record.code).includes("RVV") ? record.message : this.props.t(record.code)}</p>
                    </div>
                  </Col>
                </Row>
                <ModalHeader style={{ marginBottom: "10px" }}></ModalHeader>
                <Row>
                  <Col lg={12}>
                    <div style={{ textAlign: "right" }}>
                      <Button
                        type="close"
                        className="btn btn-secondary save-customer"
                        onClick={() => {
                          this.props.onCloseModalClick();
                          this.setState({ collapse: false });
                        }}                  >
                        {this.props.t("close")}
                      </Button>
                    </div>
                  </Col>
                </Row>
              </ModalBody>

            )
            :
            (
              <ModalBody>
                <Row>
                  <Col lg={18}>
                    <div>

                      <h5 style={{ color: "red" }}> <i className="bx bx-error" style={{ "marginRight": "3px", "marginTop": "-4px", fontSize: "1.5em", color: "red" }} />{this.props.t("operationFailed")}</h5>
                    </div>
                    <div className="modal-body">
                      <p>{record.code}</p>
                      <p>{this.props.t(record.code)}</p>
                      <Link
                        to="#"
                        onClick={this.t_collapse}
                        style={{ cursor: "pointer" }}
                      >
                        {this.props.t("details")}...{" "}
                      </Link>
                    </div>

                    <Collapse isOpen={this.state.collapse}>
                      <Card>
                        <CardBody>
                          <div className="d-flex">
                            <div className="flex-grow-1">
                              <div style={{ whiteSpace: "pre-wrap" }}>
                                <h6 className="font-size-14 mb-1">
                                  {this.props.t("errorCode")}
                                </h6>
                                <p className="text-muted">
                                  {record.code}
                                </p>
                                <h6 className="font-size-14 mb-1">
                                  {this.props.t("errorMessage")}
                                </h6>
                                <p className="text-muted">{record.message}</p>
                                <h6 className="font-size-14 mb-1">
                                  {this.props.t("correlationId")}
                                </h6>
                                <p className="text-muted">{record.correlationId}</p>
                                <h6 className="font-size-14 mb-1">
                                  {this.props.t("errorDetails")}
                                </h6>
                                <p className="text-muted">{record.details}</p>
                              </div>
                            </div>
                          </div>
                        </CardBody>
                      </Card>
                    </Collapse>
                  </Col>
                </Row>
                <ModalHeader style={{ marginBottom: "10px" }}></ModalHeader>
                <Row>
                  <Col lg={12}>
                    <div style={{ textAlign: "right" }}>
                      <Button
                        type="button"
                        style={{
                          color: "#FF0000",
                        }}
                        color="link"
                        className="btn btn-outline"
                        onClick={async () => {
                          if ("clipboard" in navigator) {
                            await navigator.clipboard.writeText(JSON.stringify(record));
                          }
                        }}
                      >
                        <i className="far fa-copy" style={{ fontSize: "1.3em", }} />{" "}
                        {this.props.t("CopyError")}
                      </Button>
                      <Button
                        type="close"
                        className="btn btn-secondary save-customer"
                        onClick={() => {
                          this.props.onCloseModalClick();
                          this.setState({ collapse: false });
                        }}                  >
                        {this.props.t("close")}
                      </Button>
                    </div>
                  </Col>
                </Row>
              </ModalBody>
            )
          }
        </Modal>
      </React.Fragment>
    );
  }
}

ErrorModal.propTypes = {
  onCloseModalClick: PropTypes.func,
  errorMessage: PropTypes.any,
  t: PropTypes.any,
};

export default withTranslation()(ErrorModal);